type ContentPage = {
  id: string;
  title: string;
  machineName: string;
  body: string;
};

// BACKEND

type BackendContentPage = {
  id: string;
  title: string;
  machine_name: string;
  body: string;
};

// MAPPER

const mapBackendContentPageToContentPage = (data: BackendContentPage): ContentPage => ({
  id: data.id,
  title: data.title,
  machineName: data.machine_name,
  body: data.body,
});

export const getContentPageMapper = (response: any): ContentPage =>
  mapBackendContentPageToContentPage(response.data);
